<template>
  <div class="card">
    <h5 class="card-header">Regions</h5>
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th scope="col" class="border-top-0">Name</th>
            <th class="text-center border-top-0 enabled-header">
              Enabled
              <span data-toggle="tooltip" data-placement="top" title="Enables or disables the region for the organization.">
                <fa icon="question-circle" />
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr colspan="12" v-if="!items.length" class="text-muted text-center">
            <td colspan="12">
              No regions
            </td>
          </tr>
          <tr v-for="item in items" :key="item.id">
            <td>
              <span class="pt-2" :class="item.status !== 'enabled' ? 'text-muted' : ''">{{ item.displayName }}</span>
            </td>
            <td class="text-center">
              <div class="custom-control custom-switch">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  :id="item.id"
                  :disabled="loadingMessage"
                  :checked="item.status === 'enabled'"
                  @change="toggle(item, $event)"
                />
                <label class="custom-control-label" :for="item.id"></label>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="card-footer">
      <ErrorSummary :error="error" />
      <form ref="form" class="mt-3 needs-validation" :class="formWasValidated ? 'was-validated' : ''" novalidate @submit.prevent>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                id="displayName"
                placeholder="name"
                required
                v-model="displayName"
                :disabled="loadingMessage"
                @keyup.enter="submit"
              />
              <div class="invalid-feedback">Please provide a name.</div>
            </div>
          </div>
          <div class="mr-3">
            <button type="button" class="btn btn-primary" @click="submit" :disabled="loadingMessage" @keyup.enter="submit">
              <span v-if="loadingMessage" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              {{ loadingMessage ? loadingMessage : "Add" }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import ErrorSummary from "@/components/ErrorSummary.vue";

export default {
  components: {
    ErrorSummary,
  },
  props: {
    organizationId: String,
  },
  data() {
    return {
      loadingMessage: null,
      formWasValidated: false,
      error: null,

      displayName: null,
      items: [],
    };
  },
  created() {
    this.load();
  },
  mounted() {
    $('[data-toggle="tooltip"]').tooltip({ boundary: "window" });
  },
  watch: {
    organizationId() {
      this.load();
    },
  },
  methods: {
    load() {
      this.loadingMessage = "Loading...";
      this.$axios
        .get(`/v1/organizations/${this.organizationId}/regions`)
        .then(res => (this.items = res.data))
        .catch(() => this.$router.push("/404"))
        .finally(() => (this.loadingMessage = null));
    },
    reset() {
      this.loadingMessage = false;
      this.formWasValidated = false;
      this.successMessage = null;
      this.error = null;
      this.displayName = null;
    },
    submit() {
      const payload = {
        displayName: this.displayName,
      };

      // reset
      this.reset();

      // validations
      if (!this.$refs.form.checkValidity()) {
        this.formWasValidated = true;
        return;
      }

      // api
      this.loadingMessage = "Adding...";
      this.$axios
        .post(`/v1/organizations/${this.organizationId}/regions`, payload)
        .then(() => {
          this.reset();
          this.load();
        })
        .catch(err => (this.error = err))
        .finally(() => (this.loadingMessage = null));
    },
    toggle(item, $event) {
      const payload = {
        displayName: item.displayName,
        status: $event.target.checked ? "enabled" : "disabled",
      };

      this.loadingMessage = "Saving...";
      this.$axios
        .put(`/v1/organizations/${this.organizationId}/regions/${item.id}`, payload)
        .then(() => {
          this.reset();
          this.load();
        })
        .catch(err => (this.error = err))
        .finally(() => (this.loadingMessage = null));
    },
  },
};
</script>

<style lang="scss" scoped>
.table-responsive {
  height: 400px;
  overflow-y: scroll;

  table {
    margin-bottom: 0;

    thead tr:nth-child(1) th {
      background: white;
      position: sticky;
      top: 0;
      z-index: 10;
    }

    .enabled-header {
      width: 115px;
    }
  }
}

.custom-control-label {
  cursor: pointer;
}
</style>
